// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__G79Zi","title":"styles_title__kDnhf","item":"styles_item__KbZJ+","text":"styles_text__7Pnng"};